import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import { useConsolidatedRef, useFocusTrap } from '../../hooks';
import type { RefElement } from '../../types';

import { StyledDialog } from './Dialog.styles';
import type { DialogProps } from './Dialog.types';

export default forwardRef<RefElement<DialogProps>, PropsWithoutRef<DialogProps>>(function Dialog(
  {
    arrow = true,
    target,
    portal,
    strategy,
    placement,
    children,
    progress,
    focusTrap = true,
    ...restProps
  },
  ref
) {
  const dialogRef = useConsolidatedRef(ref);

  useFocusTrap(focusTrap ? dialogRef : null, false);

  return (
    <StyledDialog
      {...restProps}
      role='dialog'
      arrow={arrow}
      aria-modal={false}
      aria-busy={!!progress}
      ref={dialogRef}
      target={target}
      portal={portal}
      strategy={strategy}
      placement={placement}
    >
      {children}
    </StyledDialog>
  );
});
